<div class="slide-content flex flex-col items-center justify-between">
  <div
    class="text-center flex flex-col gap-0 flex-shrink-0"
    [ngClass]="{ 'gap-4': isLastTutorialSlide, 'gap-8': JourneyRoute }"
  >
    <h1 class="outfit extra-bold heading-large">{{ slide.title | translate }}</h1>
    <p class="paragraph-medium font-normal outfit sub-text inline-block">
      <span> {{ slide.subTitleStart | translate }}</span>
      <span [ngClass]="{ 'text-bold': $index === 1 || $index === 2 }"> {{ slide.subTitleValue | translate }}</span>
      <span> {{ slide.subTitleEnd | translate }}</span>
    </p>
  </div>
  <div class="flex justify-center items-center my-4 image-container">
    <img [src]="slide.img" [alt]="slide.title | translate" />
  </div>
  <div class="w-full text-center mb-6 sm:mb-8 inline-block flex-shrink-0 description">
    <span class="paragraph-medium font-normal outfit">{{ slide.descriptionStart | translate }}</span>
    @if (doesUrlInclude('journey')) {
      <a
        class="paragraph-medium mx-1"
        [ngClass]="{ 'text-bold-highlight': $index === 0 || $index === 1, 'link-bold': $index === 2 }"
        (click)="openLink(slide.link)"
        >{{ slide.value | translate }}</a
      >
    }
    @if (doesUrlInclude('tutorial')) {
      <span
        class="paragraph-medium"
        [ngClass]="{
          'blue-highlight': $index === 2,
          'text-bold': $index === 4 || $index === 9,
          'text-highlight': $index === 10
        }"
        (click)="openLink(slide.link)"
        >{{ slide.value | translate }}</span
      >
    }
    <span class="paragraph-medium font-normal outfit">{{ slide.descriptionEnd | translate }}</span>
    <div class="flex justify-center items-center">
      @if (slide.step) {
        <ul class="flex flex-col list-disc justify-center items-start">
          @for (stepItem of slide.step; track stepItem) {
            <li class="paragraph-medium list-disc float-left font-bold outfit">
              {{ stepItem | translate }}
            </li>
          }
        </ul>
      }
    </div>
  </div>
</div>
